// extracted by mini-css-extract-plugin
module.exports = {"customSelectContainer":"CustomSelect_customSelectContainer__tlQAA","customSelectTitle":"CustomSelect_customSelectTitle__TC5uF"};